import React from 'react';
import { Link } from 'react-router-dom';
import './GrainsHero.css';

// We can reuse a decorative graphic you already have
import graphicImg from '../../assets/images/stats-hero-graphic.png';

const GrainsHero = () => {
  return (
    <section className="grains-hero-section">
      <div className="grains-hero-content">
        <h1>Market Intelligence across the grain value chain</h1>
        <p>
          Unlock prices, trade data, and strategic insights across wheat, rice, maize, and soybeans powering informed decisions across the grain lifecycle.
        </p>
        <Link to="/signup">
          <button className="book-demo-btn">Book a demo</button>
        </Link>
      </div>
      <div className="grains-hero-graphic">
        <img src={graphicImg} alt="Grain Market Intelligence Graphic" />
      </div>
    </section>
  );
};

export default GrainsHero;